var modalOverlayStyle = {
    zIndex: 10,
    // use hsla instead of rgba due to it having better browser compatibility:
    // https://caniuse.com/mdn-css_types_color_hsla
    backgroundColor: 'hsla(0, 0%, 0%, 0.6)',
};
export default modalOverlayStyle;
